/**
 * @file newsroom.js
 */
import {getResultCountHtml} from "./view-helpers";

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  function updateResultCountAllNews() {
    // Ensure we have results first
    let pagesCurrentItem = document.querySelector('.insights-display span[data-pages-current]');
    let resultsDisplay = document.getElementById('resultCount');

    if (pagesCurrentItem && resultsDisplay) {
      const pagesCurrent = parseInt(pagesCurrentItem.textContent);
      const itemsPerPage = parseInt(document.querySelector('.insights-display span[data-items-per-page]').textContent);
      const itemsTotal = parseInt(document.querySelector('.insights-display span[data-items-total]').textContent);
      resultsDisplay.innerHTML = getResultCountHtml(pagesCurrent, itemsPerPage, itemsTotal);
    } else {
      if (resultsDisplay) {
        resultsDisplay.innerHTML = '';
      }
    }
  }

  Drupal.behaviors.kodakAllNews = {
    attach: function (context, settings) {
      once('AllNewsBlock', '.paragraph--type--all-news-block, .paragraph--type--all-awards-block', context).forEach((element) => {
        updateResultCountAllNews();
      });
    }
  };

  // Re-apply the behavior and update result count on AJAX updates.
  $(document).ajaxComplete(function () {
    if ($('.paragraph--type--all-news-block, .paragraph--type--all-awards-block').length) {
      // Re-attach the behavior with the document context to handle all elements.
      Drupal.behaviors.kodakAllNews.attach(document, drupalSettings);
      // Call updateResultCount again to update the result count after AJAX completes
      updateResultCountAllNews();
    }
  });

})(jQuery, Drupal, drupalSettings, once);
